export default __webpack_public_path__ + "static/media/balance-wellness-slack.e0ace55e.md";